import React, { useEffect, useState, useContext } from "react";
import { Button, Modal, Form, Input, message } from "antd";
import Service from "../../extra/getAPI";
import { AuthContext } from "./../../context/AuthProvider";
import Warning from "./../../assets/images/warning.png";
import Success from "./../../assets/images/succes.png";
import History from "../../routes/history";

function MDConfirmAndDone(props) {
  const { profile } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const Send = () => {
    props.onFinish();
    props.handleCancel();
  };

  return (
    <>
      <Modal
        footer={false}
        className="modal-custom"
        visible={props?.open}
        centered={true}
        closable={false}
        // onCancel={props?.handleCancel}
        style={{ borderRadius: 10, maxWidth: "350px" }}
      >
        <div style={{ textAlign: "center", fontSize: 18 }}>
          <div>
            <img src={props.done ? Success : Warning} style={{ width: 80 }} />
          </div>
          <div style={{ marginTop: 10 }}>
            <b>{props.done ? "Thành công" : "Thông báo"}</b>
          </div>
        </div>
        {props.done && (
          <div
            style={{ margin: "10px 0px", fontSize: 14, textAlign: "center" }}
          >
            Bạn đã gửi hồ sơ thành công
          </div>
        )}
        {!props.done && (
          <div style={{ margin: "10px 0px", fontSize: 14 }}>
            Vui lòng kiểm tra kỹ thông tin trước khi gửi đi. Bạn có muốn kiểm
            tra lại thông tin?
          </div>
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: 15,
          }}
        >
          {!props.done && (
            <>
              <Button
                onClick={() => props?.handleCancel()}
                type="primary"
                style={{
                  background: "#fff",
                  fontSize: 14,
                  border: "1px solid #007185",
                  fontWeight: 600,
                  width: "48%",
                  color: "#007185",
                }}
              >
                Kiểm tra lại
              </Button>
              <Button
                onClick={() => Send()}
                type="primary"
                style={{
                  background: "#007185",
                  fontSize: 14,
                  border: "1px solid #007185",
                  fontWeight: 600,
                  width: "48%",
                }}
              >
                Gửi đi
              </Button>
            </>
          )}
          {props.done && (
            <Button
              onClick={() => {
                props?.handleCancel();
                History.push('/upload-chung-tu');
              }}
              type="primary"
              style={{
                background: "#007185",
                fontSize: 14,
                border: "1px solid #007185",
                fontWeight: 600,
                width: "100%",
                color: "#fff",
              }}
            >
              Đóng
            </Button>
          )}
        </div>
      </Modal>
    </>
  );
}

export default MDConfirmAndDone;
